var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: {
        href: _vm.urlWishList,
        rel: "nofollow",
        "aria-label": _vm.$translate("Ceres::Template.wishList")
      }
    },
    [
      _c("button", { staticClass: "shop-nav__btn" }, [
        _c("i", { staticClass: "icon__wish-list" }, [
          _c("span", { staticClass: "shop-nav__wish-list-wrap" }, [
            _c("span", { staticClass: "shop-nav__wish-list-amount" }, [
              _vm._v(_vm._s(_vm.wishListCount))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "wish-list-text" }, [
          _vm._v(_vm._s(_vm.$translate("Ceres::Template.wishList")))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }